<template>
  <div :class="classes">
      <pt-page-title title="商品审核" :isSearch="true" :searchKey="searchKey"  @search="search" @emptySearch="emptySearch" isParams>
          <!-- <el-button slot="before-left" type="primary" @click="created_goods">新建商品</el-button> -->
      </pt-page-title>
      <pt-page-menu-filter :tabs="tabs" v-model="selectTab" @fromRouter="fromRouter"></pt-page-menu-filter>
      <pt-goods-manage-table :tableLabels="selectTab=='PUBLISHED'?tableLabels:revirewedGoodsLabel" :queryParams="queryParams" ref="goodsTable" :isFromRouter="isFromRouter">
        <template >
            <el-table-column label="申请人">
                <template slot-scope="scope">
                    {{scope.row.goodsDTO&&scope.row.goodsDTO.proposer&&scope.row.goodsDTO.proposer.name}}
                </template>
            </el-table-column>
            <el-table-column label="审批人" v-if="isShowApprover">
                <template slot-scope="scope">
                    {{scope.row.goodsDTO&&scope.row.goodsDTO.approver&&scope.row.goodsDTO.approver.name}}
                </template>
            </el-table-column>
           <el-table-column label="操作">
               <template slot-scope="scope">
                   <template v-if="HAS_GOODS_PUBLISH">
                    <template v-if="selectTab=='WAITING_FOR_APPROVAL'">
                        <el-button type="text" @click="reviewGoods(scope.row)">审核上架</el-button>
                        <el-button type="text" @click="reject(scope.row)">驳回</el-button>
                    </template>
                    <template v-else-if="selectTab=='PUBLISHED'">
                        <el-button type="text" @click="slotOut(scope.row)">下架</el-button>
                    </template>
                  </template>
                    <el-button type="text" @click="reviewIframe(scope.row)">预览</el-button>
                     <el-button type="text" @click="getGoodsDetail(scope.row)">详情</el-button>
                </template>
           </el-table-column>
        </template>
      </pt-goods-manage-table>
      <el-dialog :visible.sync ="is_review" title="商品上架确认" :class="$style['review-dialog']" @close="closeDialog">
          <review-goods :goodsDetail="goodsDetail" @closeDialog="closeDialog" v-if="is_review"></review-goods>
      </el-dialog>
      <review-goods-iframe :is-dialog="is_review_iframe"  @closeDialog="closeDialog" :goods-id="review_id"></review-goods-iframe>
  </div>
</template>

<script>
// 组件class前缀
import ptGoodsManageTable from '../pt-goods-manage/pt-goods-manage-table/withData.vue'
import { pageStutesTabs, goodsTableLabels, revirewedGoodsLabel } from './review-options'
import reviewGoods from './review-goods'
import { hasPermissions } from 'utils/permissions'
import reviewGoodsIframe from 'cps/mall-manage/pt-goods-manage/review-goods-iframe'
const PERM_MALL_GOODS_PUBLISH = 'PERM_MALL_GOODS_PUBLISH'// 商品上下架权限
const prefixCls = 'pt-goods-review'
export default {
  name: 'pt-goods-review',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    // 是否显示“审批人”列
    isShowApprover () {
      return this.selectTab === 'PUBLISHED'
    },
    HAS_GOODS_PUBLISH () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_MALL_GOODS_PUBLISH)
    }
  },
  components: {
    ptGoodsManageTable,
    reviewGoods,
    reviewGoodsIframe
  },
  data () {
    return {
      tabs: pageStutesTabs,
      tableLabels: goodsTableLabels,
      revirewedGoodsLabel: revirewedGoodsLabel,
      is_review: false,
      is_review_iframe: false,
      review_id: '',
      selectTab: '',
      goodsDetail: {},
      queryParams: {},
      searchKey: '',
      isFromRouter: false
    }
  },
  watch: {
    selectTab: {
      handler: function (val, old) {
        this.searchKey = null
        this.queryParams = { ...this.$route.query }
      },
      immediate: true
    }
  },
  methods: {
    fromRouter (val) {
      this.isFromRouter = val
    },
    search (val) {
      this.isFromRouter = false
      this.searchKey = val
      this.queryParams = { ...this.queryParams, searchKey: val }
    },
    emptySearch () {
      this.$delete(this.queryParams, 'searchKey')
    },
    reviewIframe (val) {
      this.is_review_iframe = true
      this.review_id = val.goodsDTO.id
    },
    closeDialog (val) {
      this.is_review = false
      this.is_review_iframe = false
      if (val) {
        this.goods_list()
      }
    },
    goods_list () {
      let page = this.$refs.goodsTable.page
      this.$refs.goodsTable.getGoodsList(page)
    },
    detail () {
      this.$router.push('/goods-manage/goods-form/false/0')
    },
    created_goods () {
      this.$router.push('/goods-manage/goods-form/false/0')
    },
    reviewGoods (val) {
      this.is_review = true
      this.goodsDetail = val
    },
    getGoodsDetail (val) {
      this.$router.push('/goods-manage/goods-detail/' + val.goodsDTO.id)
    },
    // 下架
    slotOut (val) {
      this.$confirm('您确定将该商品下架吗', '商品下架', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(res => {
        this.$emit('slotOut', val.goodsDTO.id)
      }).catch(_ => {})
    },
    reject (val) {
      this.$confirm('您确定驳回该商品上架请求吗', '商品上架驳回', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(res => {
        this.$emit('approvalReject', val.goodsDTO.id)
      }).catch(_ => {})
    }

  },
  created () {
    if (!this.$store.getters.showStockQuantity) {
      this.tableLabels.forEach((item, index) => {
        if (item.label === '库存') {
          this.tableLabels.splice(index, 1)
        }
      })
      this.revirewedGoodsLabel.forEach((etem, index) => {
        if (etem.label === '库存') {
          this.revirewedGoodsLabel.splice(index, 1)
        }
      })
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

.review-dialog{
    :global
    .el-dialog{
        width: 30%;
        min-width: 400PX;
    }
    .el-dialog__body{
        padding: 15px 20px 30px
    }
:global
.el-button{
    margin-right: 10px;
    & +.el-button{
        margin-left: 0
    }
}
}
</style>
